<template>
  <div class="recipeSearchHeader">
    <div class="content headerHeight">
      <div class="alignBottomOfSearch">
        <div class="recipeWelcome centerAlign">
          <h1 v-if="isBreakfast">Good morning {{$store.state.user.scope.firstname}}!</h1>
          <h1 v-if="isLunch">Good afternoon {{$store.state.user.scope.firstname}}!</h1>
          <h1 v-if="isDinner">Good evening {{$store.state.user.scope.firstname}}!</h1>
          <h1 v-if="isNight">Good night, {{$store.state.user.scope.firstname}}</h1>
          <p>Lets get started with some healthy recipe ideas</p>
          <mu-row style="margin-bottom: 38px">
            <mu-col width="100" desktop="70" tablet="70" style="margin: 0 auto">
              <mu-row>
                <mu-col width="100" desktop="100" tablet="100">
                  <mu-raised-button
                    class="recipeHvrBtn mobileSpacing"
                    @click.native="goSearch"
                    label="Advanced search">
                  </mu-raised-button>
                  <mu-raised-button
                    class="recipeHvrBtn"
                    @click.native="goFavorites"
                    label="My favourites">
                  </mu-raised-button>
                </mu-col>
              </mu-row>
            </mu-col>
          </mu-row>
        </div>
        <form @submit.prevent="submitSearch" v-on-clickaway="onBlur" style="position: relative">
          <input autocomplete="off" id="txtAutoSearch" v-model="params.q" class="recipeSearch" type="text" placeholder="Search by; ingredient, title or category" @focus="onFocus">
          <mu-circular-progress v-if="isSearching" style="width: 24px;height: 24px;position: absolute;right: 0;top: 27px;right: 18px;"></mu-circular-progress>
          <transition name="slide-up-down" enter-active-class="animated fadeInUp"
                      leave-active-class="animated fadeOutDown">
            <div class="suggestion-wrapper" style="position: relative"
                 v-show="isAutoCompleteOpen && suggestions.length > 0">
              <div class="suggestions" style="position:absolute">
                <div
                  v-for="item, index in suggestions"
                  class="item"
                  :class="{'active': index === suggestionIndex}"
                  @click="submitSearch"
                  @mouseover="onItemMouseover(index)">
                  {{item.title}}
                </div>
              </div>
            </div>
          </transition>
          <button type="submit" style="display: none;"></button>
        </form>
      </div>
    </div>
    <div class="searchArea"></div>
    <div class="recipeGradient"></div>
  </div>
</template>

<script>
  import 'animate.css'
  import {directive as onClickaway} from 'vue-clickaway';
  import {TweenMax, Power2, TimelineLite} from 'gsap'
  import $ from 'jquery'
  import RecipeApi from '../../../api/Recipes'
  import TimingsMixin from '../Mixins/Timings'
  import MuRaisedButton from "muse-ui/src/raisedButton/raisedButton";
  import axios from 'axios'
  import {Observable} from 'rxjs/Rx'
  import MuCircularProgress from "muse-ui/src/circularProgress/circularProgress";

  export default {
    directives: {
      onClickaway: onClickaway,
    },
    components: {
      MuCircularProgress,
      MuRaisedButton
    },
    name: "recipe-search-header",
    mixins: [TimingsMixin],
    data() {
      return {
        isSearching: false,
        isAutoCompleteOpen: false,
        suggestionIndex: 0,
        suggestions: [],
        params: {
          q: null
        }
      }
    },
    mounted() {
      let self = this;
      /**
      const txtSearch = document.getElementById('txtAutoSearch');
      txtSearch.addEventListener('keydown', e => {
        if (e.which === 27) {
          self.onBlur();
        }
        if (e.which === 38) {
          self.handleDirectionalKey('up');
        }
        if (e.which === 40) {
          self.handleDirectionalKey('down');
        }
      });
       **/
      /**
      Observable.fromEvent(txtSearch, 'input')
        .map(x => x.currentTarget.value)
        .debounceTime(250)
        .subscribe((eventText) => self.handleDebouncedText(eventText));
       **/
    },
    methods: {
      onItemMouseover(index) {
        this.suggestionIndex = index;
      },
      onBlur() {
        this.isAutoCompleteOpen = false;
      },
      onFocus() {
        this.isAutoCompleteOpen = true;
      },
      handleDirectionalKey(direction) {
        let self = this;
        if (self.suggestions.length > 0) {
          if (direction === 'up') {
            self.isAutoCompleteOpen = true;
            if (self.suggestionIndex !== 0) {
              self.suggestionIndex--;
              self.$nextTick(function () {
                TweenLite.to($('.suggestions'), 0.2, {
                  scrollTo: {
                    y: $('.item.active')
                  }
                })
              });
            }
            else {
              self.suggestionIndex = self.suggestions.length - 1;
              self.$nextTick(function () {
                TweenLite.to($('.suggestions'), 0.2, {
                  scrollTo: {
                    y: $('.item.active')
                  }
                })
              })
            }
          }
          if (direction === 'down') {
            self.isAutoCompleteOpen = true;
            if (self.suggestionIndex !== (self.suggestions.length - 1)) {
              self.suggestionIndex++;
              self.$nextTick(function () {
                TweenLite.to($('.suggestions'), 0.2, {
                  scrollTo: {
                    y: $('.item.active')
                  }
                })
              })
            }
            else {
              self.suggestionIndex = 0;
              self.$nextTick(function () {
                TweenLite.to($('.suggestions'), 0.2, {
                  scrollTo: {
                    y: $('.item.active')
                  }
                })
              })
            }
          }
        }
      },
      handleDebouncedText(eventText) {
        let self = this;
        self.suggestionIndex = 0;
        self.isAutoCompleteOpen = true;
        axios.get("https://www.diabetes.co.uk/recipe-platform/api/recipe/title?filter=" + eventText)
          .then(function (response) {
            self.suggestions = response.data;
          })
      },
      loadTypes() {
        let self = this;
        axios.get("https://www.diabetes.co.uk/recipe-platform/api/recipe/utilities/alloptions")
          .then(function (response) {
            self.$store.commit('setRecipeCategories', {
              suitabilities: response.data.suitabilities,
              dietaryTypes: response.data.dietaryTypes,
              cuisines: response.data.cuisines,
              occasions: response.data.occasions,
              categories: response.data.categories
            });
          });
      },
      submitSearch() {
        let self = this;
        let queryParams = {
          search: self.params.q,
          page: 0,
          limit: 15
        };
        if (self.suggestions.length > 0) {
          self.isSearching = true;
          self.isAutoCompleteOpen = false;
          let title = self.suggestions[self.suggestionIndex].title;
          self.params.q = title;
          RecipeApi.search({
            search: title,
            page: 0,
            limit: 15
          })
            .then(function (response) {
              self.$store.commit('setRecipeFilter', queryParams);
              self.$router.push({
                name: 'RecipeSearchResults',
                query: {
                  search: title,
                  page: 0,
                  limit: 15
                },
                params: {
                  data: response.data,
                  filterModel: queryParams
                }
              });
            });
        }
        else {
          self.isAutoCompleteOpen = false;
          self.isSearching = true;
          RecipeApi.search({
            search: self.params.q,
            page: 0,
            limit: 15
          })
            .then(function (response) {
              self.$store.commit('setRecipeFilter', queryParams);
              self.$router.push({
                name: 'RecipeSearchResults',
                query: {
                  search: self.params.q,
                  page: 0,
                  limit: 15
                },
                params: {
                  data: response.data,
                  filterModel: queryParams
                }
              });
            });
        }
      },
      goFavorites() {
        this.$router.push({
          name: 'RecipeFavorites'
        })
      },
      goSearch() {
        this.$router.push({
          name: 'RecipeSearch'
        });
      }
    }
  }
</script>

<style lang="less">

  #txtAutoSearch:focus {
    outline: none;
  }

  @media(max-width: 800px) {
    button.recipeHvrBtn {
      width: 100%;
    }
    button.recipeHvrBtn:last-child {
      width: 100%;
      margin-bottom: -80px;
    }
  }

  .isBreakfast {
    .recipeHvrBtn:hover {
      background: white !important;
      color: #58820E !important;
    }
  }

  .isLunch {
    .recipeHvrBtn:hover {
      background: white !important;
      color: #C45516 !important;
    }
  }

  .isDinner {
    .recipeHvrBtn:hover {
      background: white !important;
      color: #008575 !important;
    }
  }

  .isNight {
    .recipeHvrBtn:hover {
      background: white !important;
      color: rgb(48, 35, 174) !important;
    }
  }

  .animated {
    -webkit-animation-duration: 0.3s !important;
    animation-duration: 0.3s !important;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }

  .suggestions {
    height: 250px;
    overflow: auto;
    -webkit-overflow-scrolling: touch; /* Lets it scroll lazy */
    background: white;
    box-shadow: 0px 17px 20px #0000001f;
    border-radius: 4px;
    width: 100%;
    .item {
      &:hover {
        cursor: pointer;
      }
      padding: 8px 16px;
      &.active {
        background: #bfbfbf26;
      }
    }
  }

  @media (min-width: 800px) {
    .headerHeight {
      position: relative;
      // height: 400px;
    }
  }

  @media (max-width: 800px) {
    .recipeSearchHeader {
      // height: 464px !important;
    }


    .mobileSpacing {
      margin-bottom: 16px;
    }

    .headerHeight {
      //  height: 450px;
      padding-left: 16px;
      padding-right: 16px;
      width: 100%;
    }

    #recipes {
      padding-left: 0 !important;
      padding-right: 0 !important
    }

    .recipeSearchHeader .alignBottomOfSearch {
      position: relative !important;
      z-index: 1;
      width: 100%;
      padding-top: 72px;
    }
  }

  .alignBottomSearch .mu-raised-button {
    background: transparent !important;
  }

  .recipeWelcome.centerAlign .mu-raised-button {
    background: transparent;
    color: white;
    border-radius: 40px;
    border: 1px solid white;
    padding: 22px;
    box-shadow: none !important;

  }

  .recipeGradient {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }

  .isLunch .recipeGradient {
    background: #E76E2A;
    background: -moz-linear-gradient(45deg, rgba(245, 84, 145, 0.77) 0%, rgba(231, 110, 42, 0.62) 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(45deg, rgba(245, 84, 145, 0.77) 0%, rgba(231, 110, 42, 0.62) 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(45deg, rgba(245, 84, 145, 0.77) 0%, rgba(231, 110, 42, 0.62) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#c4f55491', endColorstr='#9ee76e2a', GradientType=1); /* IE6-9 fallback on horizontal gradient */
  }

  .isDinner .recipeGradient {
    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#00b09b+0,96c93d+100 */
    background: rgb(0, 176, 155); /* Old browsers */
    background: -moz-linear-gradient(45deg, rgba(0, 176, 155, 0.77) 0%, rgba(150, 201, 61, 0.77) 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(45deg, rgba(0, 176, 155, 0.77) 0%, rgba(150, 201, 61, 0.77) 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(45deg, rgba(0, 176, 155, 0.77) 0%, rgba(150, 201, 61, 0.77) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00b09b', endColorstr='#96c93d', GradientType=1); /* IE6-9 fallback on horizontal gradient */
  }

  .isBreakfast .recipeGradient {
    background: #B4EC51; /* Old browsers */
    background: -moz-linear-gradient(45deg, rgba(48, 35, 174, 0.7) 0%, rgba(83, 160, 253, 1) 47%, rgba(180, 236, 81, 0.7) 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(45deg, rgba(48, 35, 174, 0.7) 0%, rgba(83, 160, 253, 0.7) 47%, rgba(180, 236, 81, 0.7) 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(45deg, rgba(48, 35, 174, 0.7) 0%, rgba(83, 160, 253, 0.7) 47%, rgba(180, 236, 81, 1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#3023ae', endColorstr='#b4ec51', GradientType=1); /* IE6-9 fallback on horizontal gradient */
  }

  .isNight .recipeGradient {
    background: rgb(48, 35, 174); /* Old browsers */
    background: -moz-linear-gradient(45deg, rgba(48, 35, 174, 0.77) 0%, rgba(200, 109, 215, 0.77) 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(45deg, rgba(48, 35, 174, 0.77) 0%, rgba(200, 109, 215, 0.77) 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(45deg, rgba(48, 35, 174, 0.77) 0%, rgba(200, 109, 215, 0.77) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#3023ae', endColorstr='#c86dd7', GradientType=1); /* IE6-9 fallback on horizontal gradient */
  }

  .recipeSearchHeader {

    input.recipeSearch {
      width: 100%;
      height: 50px;
      padding-left: 16px;
      padding-right: 16px;
      border-radius: 20px;
      border: 0;
      margin-bottom: 25px;

      @media(max-width: 800px) {

        margin-top: -4px;
      }

      margin-top: 14px;

      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
    }
    .recipeSearch {
      width: 100%;
    }

    h1 {
      color: white;
      font-size: 46px;
      margin-bottom: 8px;

      @media(max-width: 800px) {
        line-height: 54px;
      }

    }

    position: relative;
    @media (min-width: 800px) {
      height: 400px;
    }

    width: 100%;
    background: url("https://res.cloudinary.com/grohealth/image/upload/q_auto/v1565092849/Low%20Carb%20Program/LCP-UK/Resources/Chocolate_Waffles_-_Recipe_Home_Image.png");
    background-size: cover;
    background-position: right;

    .alignBottomOfSearch {
      // position: absolute;
      bottom: 0;
      z-index: 999;
      width: 100%;
      position: relative !important;
      z-index: 1;
      width: 100%;
      padding-top: 116px;
    }

    .recipeWelcome {
      &.centerAlign {
        text-align: center;
      }
      p {
        color: white;
        margin-top: 0px;
        font-size: 16px;
      }
    }

  }

</style>



// WEBPACK FOOTER //
// RecipeSearchHeader.vue?4330bdaa